/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getCalendarMessageSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import { setCalendarMessageSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';

const CalendarMessageABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const calendarMessageSaleForceABTestData = useSelector(getCalendarMessageSaleForceABTest);
    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Get Campaign - Calendar Messaging',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });
    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'CalendarMessageABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Calendar Message Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== calendarMessageSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setCalendarMessageSaleForceABTest(data.contentSF));
    }

    return null;
};

CalendarMessageABTest.propTypes = {
    pageType: string.isRequired,
};

export default CalendarMessageABTest;
